/**
 * Safely converts a price value (which may be a string or number) to a number
 * @param price - The price value to convert
 * @returns A valid number, or 0 if the value cannot be converted
 */
export const toNumber = (price: string | number | undefined | null): number => {
  if (price === undefined || price === null) {
    return 0;
  }

  const num = typeof price === "string" ? parseFloat(price) : price;
  return isNaN(num) ? 0 : num;
};

/**
 * Formats a price value (which may be a string or number) as a currency string
 * @param price - The price value to format
 * @param decimals - Number of decimal places (default: 2)
 * @returns Formatted price string
 */
export const formatPrice = (
  price: string | number | undefined | null,
  decimals: number = 2,
  currency: string = "USD"
): string => {
  const num = toNumber(price);
  return num.toLocaleString("en-US", {
    style: "currency",
    currency: currency,
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};
